import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import { useAppDispatch, useAppSelector } from "@/redux/hooks";
import { memo } from "react";
import { setHotelFilters } from "../../state/extract-hotel-filter-slice";
import { HotelAccordion } from "./hotel-accordion";

const CANCELLATION_POLICY = [
  "Refundable",
  "Non-refundable",
  "Free cancellation",
  "Partial cancellation",
];

export const HotelCancellationFilter = memo(() => {
  const dispatch = useAppDispatch();
  const { selectedOption } = useAppSelector(
    (state) => state.extractHotelFilter,
  );
  const isLoading = useAppSelector(
    (state) => state.selectedHotelData.isLoading,
  );

  const selected = selectedOption?.cancellation;

  const handleChange = (value?: string) => {
    if (!value) return;

    const isSelected = selected?.some((item) => item === value);

    const updatedValue = isSelected
      ? selected?.filter((item) => item !== value)
      : [...(selected ?? []), value];

    dispatch(setHotelFilters({ cancellation: updatedValue }));
  };

  if (CANCELLATION_POLICY.length === 0) return null;

  return (
    <HotelAccordion value={"cancellation"} label={"Cancellation Policy"}>
      <div className="space-y-2">
        {CANCELLATION_POLICY.map((item: any, index: number) => {
          return (
            <div key={index} className="flex items-center space-x-2 truncate">
              <Checkbox
                disabled={isLoading}
                id={item}
                onCheckedChange={() => handleChange(item)}
                checked={selected?.includes(item) ?? false}
              />
              <Label
                htmlFor={item}
                className="font-normal cursor-pointer w-full "
              >
                <div className="flex flex-col truncate">
                  <span>{item}</span>
                </div>
              </Label>
            </div>
          );
        })}
      </div>
    </HotelAccordion>
  );
});

HotelCancellationFilter.displayName = "HotelCancellationFilter";
